import { VerticalContainer } from '@american-autonomy/ag-ui';

import DetailsView from 'components/DetailsView';
import DetailsViewCard from 'components/DetailsViewCard';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewCloseButton from 'components/DetailsViewCloseButton';
import Page from 'components/Page';

import useData from './hooks/useData';

import ChemicalDetailFields from './components/ChemicalDetailFields';
import ChemicalDetailSections from './components/ChemicalDetailSections';
import FormulationReviewModal from './components/FormulationReviewModal';
import { CARD_HEADER_DETAIL_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ChemicalDetailPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        chemical,
        dropdownMenuItems,
        formulation,
        handleClose,
        handleFormulationChanged,
        handleFormulationReviewClose,
        isFormulationReviewOpen,
        isLoading,
        modeOfAction,
        primaryClassification,
        rainfastness,
        rei
    } = useData();

    return (
        <Page testId={testId}>
            <DetailsViewCloseButton onClick={handleClose} />

            <DetailsView>
                <DetailsViewCard>
                    <DetailsViewCardHeader
                        detailType={CARD_HEADER_DETAIL_TYPE}
                        isLoading={isLoading}
                        items={dropdownMenuItems}
                        name={chemical?.labelName ?? ''}
                    />

                    <VerticalContainer className={styles.sectionsContainer}>
                        <ChemicalDetailFields
                            classification={primaryClassification}
                            epaNumber={chemical?.epaNumber ?? null}
                            formulation={formulation}
                            manufacturer={chemical?.manufacturer ?? null}
                            modeOfAction={modeOfAction}
                            ppe={chemical?.ppe ?? null}
                            ppeReentry={chemical?.ppeReentry ?? null}
                            rainfastness={rainfastness}
                            rei={rei}
                            signalWord={chemical?.signalWord ?? null}
                        />

                        <ChemicalDetailSections chemical={chemical} />
                    </VerticalContainer>
                </DetailsViewCard>
            </DetailsView>

            {chemical && (
                <FormulationReviewModal
                    chemicalId={chemical.id}
                    isOpen={isFormulationReviewOpen}
                    onClose={handleFormulationReviewClose}
                    onFormulationChanged={handleFormulationChanged}
                />
            )}
        </Page>
    );
};

export default ChemicalDetailPage;
